import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {AutocompleteInput, ReferenceInput, required, Title} from 'react-admin';
import {downloadFile, NotifyForm, schoolYears, showErrorNotify, TreeCheckboxInput} from '../../components';
import env from '../../env';

class CustomerSubjectResultTemplate extends React.Component {
    state = {
        changeSchoolYear: false,
        unitIds: [],
        schoolYearId: schoolYears[0].id,
    };

    getReportUrl = () => {
        downloadFile(`${env.baseURL}/api/reports/customerSubjectResultTemplate?` +
            `pSchoolYearId=` + this.state.schoolYearId +
            `&pUnitIds=` + this.state.unitIds, 'mau_diem_thi.xlsx')
    }

    templateAllClazzes = () => {
        if (!this.state.unitIds || this.state.unitIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách lớp")
            return;
        }
        this.getReportUrl()
    }

    validate = (values) => {
        const errors = {};
        // Copy input values to params
        if (this.state.changeSchoolYear) {
            this.setState({
                unitIds: [],
                changeSchoolYear: false
            })
        } else {
            this.setState({
                unitIds: values.unitIds
            })
        }

        return errors;
    }

    onSchoolYearChanged(e, value) {
        this.setState({
            schoolYearId: value,
            changeSchoolYear: true
        });
    }

    render() {
        return (
            <Card>
                <Title title="resources.customerSubjectResultTemplate.name"/>
                <CardContent>
                    <NotifyForm params={this.state}
                                validate={this.validate}
                                allClazzes={this.templateAllClazzes}
                    >
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <ReferenceInput source="schoolYearId"
                                                reference="schoolYears"
                                                label="resources.schoolYears.name"
                                                perPage={50}
                                                validate={required()}
                                                onChange={(e, value) => this.onSchoolYearChanged(e, value)}
                                                {...this.props} >
                                    <AutocompleteInput source="name"/>
                                </ReferenceInput>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label>Danh sách lớp *</label>
                                <div style={{maxHeight: '300px', overflow: 'auto'}}>
                                    <ReferenceInput source="unitIds"
                                                    reference="units"
                                                    perPage={999}
                                                    filter={{clazzWithParents: true, schoolYear: schoolYears[0].id}}
                                                    {...this.props} >
                                        <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
                                    </ReferenceInput>
                                </div>
                            </Grid>
                        </Grid>
                    </NotifyForm>

                </CardContent>
            </Card>
        )
    }
}

export default CustomerSubjectResultTemplate

